module.exports = __webpack_public_path__ + "img/Text with image-button-title – 1.9dc4841e.svg";